import React, {useEffect, useState} from "react";
import {FormattedMessage, injectIntl} from "react-intl";
import Text from "@amzn/meridian/text";
import { PropTypes } from 'prop-types';
import {getCurrentFormattedTime} from "../Utility";
import {useDeviceLayout} from "./common/context/DeviceLayoutContext";

/**
 * React component for getting the last refresh time in a page
 * @param deps
 * @param locale
 * @return JSX.Element
 */
const RefreshTimer = ({deps, intl}) => {
    const [latestRefreshTime, setRefreshTime] = useState("");
    useEffect(() => {
        setRefreshTime(getCurrentFormattedTime(intl.locale));
    }, deps);

    const {isMobile} = useDeviceLayout();

    const headerType = isMobile ? "b100" : "b200";

    return (
        <Text type={headerType}>
            <FormattedMessage id="common.data_last_updated" defaultMessage="Data last updated"/>: {latestRefreshTime}
        </Text>
    )
}

RefreshTimer.propTypes = {
    deps: PropTypes.array,
    locale: PropTypes.string,
};

export default injectIntl(RefreshTimer)


// WEBPACK FOOTER //
// ./src/components/RefreshTimer.js